<div class="container">
    <div class="row d-flex flex-wrap">

        <div class="col-12 col-sm-12 col-md-3">
            <h2 class="orange-header">Upload Bulk File</h2>
            <p>Need to send bulk payment requests?We’ve got you covered!</p><br>

            <h3>Use This When:</h3>
            <ul>
                <li>you have a large list of payment requests you need to send</li>
            </ul>

            <h3>What you need to do:</h3>
            <ul>
                <li>download the sample template file</li>
                <li>fill in all the details</li>
                <li>upload and send</li>
            </ul>
        </div>

        <div class="col-12 col-sm-12 col-md-9 justify-content-center align-self-center">
            <img [ngSrc]="'walkthrough-bulk-upload.gif' | assetSource"
                 alt="bulk upload"
                 class="walkthrough-image responsive-gif"
                 height="1"
                 width="1"/>
        </div>

    </div>
</div>